/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {KTCard, KTCardBody, KTIcon} from '../../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import LoadingComponent from '../../../../components/LoadingComponent/LoadingComponent'
import {getKupciPregled, getServisUtovarPaketa, utovariPakete} from '../../../../api/proizvodnja'
import notifyToast from '../../../../components/Toast/Toast'
import {PrikolicaKamionaModel, ServisUtovarPaketaModel} from '../../../../models/ProizvodnjaModel'
import {useNavigate} from 'react-router-dom'
import KupciPanelaDropdown from '../../../paneli/components/KupciPanelaDropdown/KupciPanelaDropdown'

const getPackageCheckboxKey = (item: any, key: string, value: any) =>
  `${item.shared.brojNaloga} | ${item.shared.stavka}-${key}-${value.gabarit.replaceAll(
    ' X ',
    '-'
  )}-${item.shared.brojPonude}`

const getOrderCheckboxKeys = (item: any) =>
  Object.entries(item)
    .filter(([key]) => key !== 'shared')
    .map(([key, value]: any) => getPackageCheckboxKey(item, key, value))

const KupciPregled = () => {
  const [kupci, setkupci] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>({})
  const [searchTerm, setSearchTerm] = useState('')
  const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null)
  const itemRefs = useRef<(HTMLDivElement | null)[]>([])

  const [sirina, setSirina] = useState<string>('')
  const [visina, setVisina] = useState<string>('')
  const [duzina, setDuzina] = useState<string>('')
  const [prikolicaKamiona, setPrikolicaKamiona] = useState<PrikolicaKamionaModel>()
  const [apiCreds, setApiCreds] = useState<ServisUtovarPaketaModel>()
  const [checkboxArray, setCheckboxArray] = useState<string[]>([])
  const [selectedRadio, setSelectedRadio] = useState<number>()

  const navigate = useNavigate()

  useEffect(() => {
    if (!kupci?.value) {
      setData({})
      setCheckboxArray([])

      return
    }

    setLoading(true)
    setCheckboxArray([])

    getKupciPregled(kupci?.value)
      .then((response) => {
        const parsedData = response?.data?.data ?? response?.data ?? response ?? {}

        setData(parsedData)
      })
      .catch((error) => {
        console.error(error)

        notifyToast(false, error?.response?.data?.message ?? error)
      })
      .finally(() => setLoading(false))
  }, [kupci])

  useEffect(() => {
    getServisUtovarPaketa()
      .then((response) => {
        setApiCreds(response)
      })
      .catch((error) => notifyToast(false, error?.response?.data?.message ?? error))
  }, [])

  useEffect(() => {
    if (selectedRadio === 1) {
      setPrikolicaKamiona({w: '245', h: '270', d: '1360', max_wg: '15000', id: 1})
    } else if (selectedRadio === 2) {
      setPrikolicaKamiona({w: '245', h: '300', d: '1360', max_wg: '15000', id: 1})
    } else if (selectedRadio === 3) {
      setPrikolicaKamiona({
        w: sirina ?? '',
        h: visina ?? '',
        d: duzina ?? '',
        max_wg: '15000',
        id: 1,
      })
    }
  }, [selectedRadio, sirina, visina, duzina])
  useEffect(() => {
    if (!searchTerm.trim()) {
      setHighlightedIndex(null)
      return
    }

    const lowerSearch = searchTerm.toLowerCase()

    const foundIndex = Object.values(data).findIndex((item: any) => {
      const searchableText = `
            ${Object.entries(item)
              .map(([key, value]: any) => {
                if (key === 'shared') {
                  return `
                        ${value?.brojPonude ?? ''}
                        ${value?.brojNaloga ?? ''}
                        ${value?.stavka ?? ''}
                        ${value?.partnerPonuda ?? ''}
                        ${value?.partnerPredracun ?? ''}
                        ${value?.partnerKupac ?? ''}
                        ${value?.vrsta ?? ''}
                        ${value?.boja ?? ''}
                    `
                }

                return `
                    ${key}
                    ${value?.gabarit ?? ''}
                `
              })
              .join(' ')}
        `.toLowerCase()

      return searchableText.includes(lowerSearch)
    })

    if (foundIndex !== -1) {
      setHighlightedIndex(foundIndex)

      setTimeout(() => {
        itemRefs.current[foundIndex]?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }, 100)
    } else {
      setHighlightedIndex(null)
    }
  }, [searchTerm, data])
  const formatNumber = (num: number) =>
    num.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

  const totalAll = Object.values(data).reduce((sum: number, item: any) => {
    const val = item?.shared?.totalKvadratura
    if (!val) return sum
    const num = parseFloat(String(val).replace(',', '.'))
    return sum + (isNaN(num) ? 0 : num)
  }, 0)

  const selectedTotal = checkboxArray.reduce((sum: number, item: string) => {
    try {
      const parts = item.split('-')
      const sirinaPaketa = Number(parts[2]) / 1000
      const duzinaPaketa = Number(parts[3]) / 1000

      if (isNaN(sirinaPaketa) || isNaN(duzinaPaketa)) return sum

      return sum + sirinaPaketa * duzinaPaketa
    } catch {
      return sum
    }
  }, 0)

  const onUtovariClick = () => {
    setLoading(true)

    const paketi: any[] = []

    checkboxArray.forEach((item) => {
      const a: any = item.split('-')

      paketi.push({
        w: a[2] / 10,
        h: a[4] / 10,
        d: a[3] / 10,
        q: '1',
        vr: '0',
        wg: '0',
        id: a[0] + '-' + a[1] + '-' + a[5],
      })
    })

    const params = {
      username: apiCreds?.username,
      api_key: apiCreds?.apiKey,
      bins: [prikolicaKamiona],
      items: paketi,
      params: {
        images_background_color: '255,255,255',
        images_bin_border_color: '59,59,59',
        images_bin_fill_color: '230,230,230',
        images_item_border_color: '214,79,79',
        images_item_fill_color: '177,14,14',
        images_item_back_border_color: '215,103,103',
        images_sbs_last_item_fill_color: '99,93,93',
        images_sbs_last_item_border_color: '145,133,133',
        images_width: '100',
        images_height: '100',
        images_source: 'file',
        images_sbs: '1',
        stats: '1',
        item_coordinates: '1',
        images_complete: '1',
        images_separated: '1',
      },
    }

    utovariPakete(params)
      .then((response) => {
        const totalKamiona = response.response?.bins_packed?.length ?? 1

        navigate(`utovar-kamiona`, {
          state: {data: response.response, kupac: kupci.name, totalKamiona},
        })
      })
      .catch((error) => {
        console.error(error)
        notifyToast(false, error)
      })
      .finally(() => setLoading(false))
  }

  const processPdf = () => {
    navigate(`process-pdf/${kupci.value}`, {
      state: {
        kupac: kupci.name,
      },
    })
  }

  const checkboxKeys = useMemo(
    () => Object.values(data).flatMap((item: any) => getOrderCheckboxKeys(item)),
    [data]
  )
  const isAllSelected = checkboxKeys.length > 0 && checkboxArray.length === checkboxKeys.length

  const toggleAllSelection = () => {
    if (isAllSelected) {
      setCheckboxArray([])
      return
    }

    setCheckboxArray(checkboxKeys)
  }

  const toggleOrderSelection = (orderKeys: string[]) => {
    const selectedKeys = new Set(checkboxArray)
    const isOrderSelected = orderKeys.every((key) => selectedKeys.has(key))

    if (isOrderSelected) {
      setCheckboxArray(checkboxArray.filter((key) => !orderKeys.includes(key)))
      return
    }

    setCheckboxArray(Array.from(new Set([...checkboxArray, ...orderKeys])))
  }

  const togglePackageSelection = (value: string, checked: boolean) => {
    if (checked) {
      setCheckboxArray(Array.from(new Set([...checkboxArray, value])))
      return
    }

    setCheckboxArray(checkboxArray.filter((key) => key !== value))
  }

  return (
    <KTCard className='shadow-sm'>
      <ToastContainer />

      {loading && (
        <div
          className='position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25 d-flex align-items-center justify-content-center'
          style={{zIndex: 9999}}
        >
          <div className='text-center bg-white rounded p-8 shadow'>
            <div className='spinner-border text-primary mb-3' />
            <div className='fw-bold'>Učitavanje...</div>
          </div>
        </div>
      )}

      <KTCardBody className='py-4'>
        <div className='d-flex align-items-center justify-content-between mb-6'>
          <h3 className='fw-bold mb-0'>📦 Pregled paketa</h3>
        </div>
        <div className='mb-6'>
          <label className='fw-bold fs-6 mb-2'>Kupci panela</label>

          <KupciPanelaDropdown
            value={kupci}
            onChange={(name, value) => setkupci({name, value})}
            selectName='Kupci panela'
          />
        </div>
        <div className='card border-0 shadow-sm mb-6 bg-light'>
          <div className='card-body p-6'>
            <div className='row g-6 align-items-start'>
              <div className='col-xl-7'>
                <label className='fw-bold fs-6 mb-4 d-block'>🚛 Izaberi dimenzije prikolice</label>

                <div className='d-flex flex-column gap-4'>
                  <div
                    className={`rounded p-4 border ${
                      selectedRadio === 1
                        ? 'border-success bg-light-success'
                        : 'border-gray-300 bg-white'
                    }`}
                  >
                    <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                      <div className='d-flex align-items-center'>
                        <input
                          className='form-check-input me-3'
                          type='radio'
                          name='flexRadioDefault'
                          id='flexRadioDefault1'
                          checked={selectedRadio === 1}
                          onChange={() => setSelectedRadio(1)}
                        />
                        <label
                          className='form-check-label fw-bold mb-0'
                          htmlFor='flexRadioDefault1'
                        >
                          STANDARDNI KAMION
                        </label>
                      </div>

                      {selectedRadio === 1 && (
                        <div className='row g-2'>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={245}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={270}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={1360}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className={`rounded p-4 border ${
                      selectedRadio === 2
                        ? 'border-success bg-light-success'
                        : 'border-gray-300 bg-white'
                    }`}
                  >
                    <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                      <div className='d-flex align-items-center'>
                        <input
                          className='form-check-input me-3'
                          type='radio'
                          name='flexRadioDefault'
                          id='flexRadioDefault2'
                          checked={selectedRadio === 2}
                          onChange={() => setSelectedRadio(2)}
                        />
                        <label
                          className='form-check-label fw-bold mb-0'
                          htmlFor='flexRadioDefault2'
                        >
                          MAXI / MEGA KAMION
                        </label>
                      </div>

                      {selectedRadio === 2 && (
                        <div className='row g-2'>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={245}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={300}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              disabled
                              value={1360}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className={`rounded p-4 border ${
                      selectedRadio === 3
                        ? 'border-warning bg-light-warning'
                        : 'border-gray-300 bg-white'
                    }`}
                  >
                    <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                      <div className='d-flex align-items-center'>
                        <input
                          className='form-check-input me-3'
                          type='radio'
                          name='flexRadioDefault'
                          id='flexRadioDefault3'
                          checked={selectedRadio === 3}
                          onChange={() => setSelectedRadio(3)}
                        />
                        <label
                          className='form-check-label fw-bold mb-0'
                          htmlFor='flexRadioDefault3'
                        >
                          OPCIONALNO [cm]
                        </label>
                      </div>

                      {selectedRadio === 3 && (
                        <div className='row g-2'>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              placeholder='Širina'
                              value={sirina}
                              onChange={(e) => setSirina(e.target.value)}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              placeholder='Visina'
                              value={visina}
                              onChange={(e) => setVisina(e.target.value)}
                            />
                          </div>
                          <div className='col-auto'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100px'
                              placeholder='Dužina'
                              value={duzina}
                              onChange={(e) => setDuzina(e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='row mt-4'>
                  <div className='col-12'>
                    <div className='card bg-light border p-4 d-flex flex-row justify-content-between align-items-center'>
                      <div>
                        <div className='fw-bold text-gray-700'>Ukupno (svi nalozi)</div>
                        <div className='fs-2 fw-bold text-success'>{formatNumber(totalAll)} m²</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-xl-5'>
                <div className='d-flex flex-wrap justify-content-xl-end gap-3'>
                  <button
                    className='btn btn-light-primary'
                    onClick={toggleAllSelection}
                    hidden={!kupci}
                  >
                    {isAllSelected ? 'Odznaci sve' : 'Oznaci sve'}
                  </button>

                  {kupci && (
                    <button className='btn btn-dark' onClick={processPdf}>
                      📄 Kreiraj PDF
                    </button>
                  )}

                  <button
                    className='btn btn-success'
                    onClick={onUtovariClick}
                    disabled={
                      !checkboxArray.length ||
                      !selectedRadio ||
                      (selectedRadio === 3 && (!sirina || !visina || !duzina))
                    }
                  >
                    {!loading && (
                      <>
                        <KTIcon iconName='truck' className='fs-2 me-2' />
                        Utovari u kamion
                      </>
                    )}
                  </button>
                </div>
                <div className='row'>
                  <div className='col-6 mt-5'>
                    <div className='position-relative'>
                      <input
                        type='text'
                        className='form-control form-control-solid pe-10'
                        placeholder='Traži...'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Escape') {
                            setSearchTerm('')
                          }
                        }}
                      />

                      {searchTerm && (
                        <button
                          type='button'
                          className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-2'
                          onClick={() => setSearchTerm('')}
                          style={{
                            border: 'none',
                            background: 'transparent',
                          }}
                        >
                          <KTIcon iconName='cross' className='fs-2' />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <LoadingComponent />
        ) : (
          <div style={{maxHeight: '75vh', overflow: 'auto'}}>
            {Object.values(data).length > 0 ? (
              Object.values(data).map((item: any, index) => {
                const orderCheckboxKeys = getOrderCheckboxKeys(item)
                const isOrderSelected =
                  orderCheckboxKeys.length > 0 &&
                  orderCheckboxKeys.every((key) => checkboxArray.includes(key))

                return (
                  <div
                    key={index}
                    ref={(el) => (itemRefs.current[index] = el)}
                    className={`mb-8 border rounded overflow-hidden shadow-sm bg-white ${
                      highlightedIndex === index ? 'border-warning border-4 shadow-lg' : ''
                    }`}
                  >
                    <div className='bg-success text-white p-5'>
                      <div className='h5 d-flex justify-content-center py-2 mb-4 fw-bold'>
                        Stanje paketa prema nalogu / ponudi
                      </div>

                      <div className='row'>
                        <div className='col-md-6 h6 mb-2 mb-md-0'>
                          Alternativa Ponuda: {item?.shared?.brojPonude ?? ''} Nalog:{' '}
                          {item?.shared?.brojNaloga ?? ''} ({item?.shared?.stavka ?? ''})
                        </div>
                        <div className='col-md-6 h6'>
                          Vrsta: {item?.shared?.vrsta ?? ''} | Boja: {item?.shared?.boja ?? ''}
                        </div>
                      </div>
                      <div className='form-check form-check-custom form-check-solid mt-4'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id={`select-order-${index}`}
                          checked={isOrderSelected}
                          onChange={() => toggleOrderSelection(orderCheckboxKeys)}
                        />
                        <label
                          className='form-check-label text-white'
                          htmlFor={`select-order-${index}`}
                        >
                          {isOrderSelected ? 'Odznaci nalog' : 'Oznaci nalog'}
                        </label>
                      </div>
                    </div>

                    {Object.entries(item).map(([key, value]: any) => {
                      let val = ''

                      if (key !== 'shared') {
                        val = getPackageCheckboxKey(item, key, value)
                      }

                      if (key !== 'shared') {
                        return (
                          <div className='row p-4 align-items-stretch border-top' key={val}>
                            <div className='col-xl-1 col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-center justify-content-center mb-4 mb-md-0'>
                              <input
                                type='checkbox'
                                value={val}
                                checked={checkboxArray.includes(val)}
                                onChange={(e) => {
                                  togglePackageSelection(val, e.target.checked)
                                }}
                                style={{
                                  width: '22px',
                                  height: '22px',
                                  cursor: 'pointer',
                                }}
                              />
                            </div>

                            <div className='col-xl-3 col-lg-3 col-md-10 col-sm-10 col-12 mb-4 mb-xl-0'>
                              <div className='h-100 rounded p-4 border border-primary bg-light-primary'>
                                <div className='h6 fw-bold text-primary mb-2'>Paket: {key}</div>

                                <div className='h6 mb-0 text-gray-800'>
                                  [S x D x V]: {value.gabarit}
                                </div>
                              </div>
                            </div>

                            <div className='col-xl-8 col-lg-8 col-md-12 col-12'>
                              <table className='table table-bordered table-striped align-middle mb-0'>
                                <thead className='table-dark'>
                                  <tr>
                                    <th>Dužina</th>
                                    <th>Količina</th>
                                    <th>M2</th>
                                    <th>Status</th>
                                    <th>Isporučen</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {Object.entries(value.data).map(([rowKey, rowVal]: any) => (
                                    <tr key={rowKey}>
                                      <td>{rowVal.duzina}</td>

                                      <td>{rowVal.brPanela}</td>

                                      <td>{rowVal.kvadratura}</td>

                                      <td
                                        style={{
                                          backgroundColor: item.shared.statusBoja,
                                        }}
                                      >
                                        {item.shared.status}
                                      </td>

                                      <td
                                        style={{
                                          backgroundColor: item.shared.isporucenBoja2,
                                        }}
                                      >
                                        {item.shared.isporucen}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )
                      }

                      return null
                    })}

                    <div className='p-4 border-top bg-light'>
                      <div className='fw-bold'>
                        Ukupna količina stavke na nalogu: {item?.shared?.totalKvadratura}
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className='text-center py-10 text-muted'>Nema podataka</div>
            )}
          </div>
        )}
      </KTCardBody>
    </KTCard>
  )
}

export default KupciPregled
